var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.133-1.733h34.133V32.4H2.133V-1.733z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.533-1.723h46.65V32.4h-46.65V-1.723z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.48-3.27H10.38v14.766H-4.48V-3.27zM18.628-3.27h28.757v14.766H18.628V-3.27zM-4.48 19.71h14.666v15.052H-4.48v-15.05zM18.8 19.853h27.98v14.91H18.8v-14.91z",
    fill: "#D72828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.443-3.27h4.295v36.38h-4.295V-3.27z",
    fill: "#003897"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.48 13.256h50.866v4.23H-4.48v-4.23z",
    fill: "#003897"
  })));
};
export default SvgNo;